import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import SortBar from "../gallery/sort-bar";
import GallerySearchBar from "../gallery/gallery-search-bar";
import { sortByProperty } from "../../functions/sort-by-property";

class FavoriteItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = { imgError: false };
        this.imgRef = null;
    }

    componentDidMount() {
        if (this.imgRef && this.imgRef.complete && this.imgRef.naturalHeight === 0) {
            this.setState({ imgError: true });
        }
    }

    handleImageError = () => {
        this.setState({ imgError: true });
    }

    render() {
        var item = this.props.item;
        var imgError = this.state.imgError;
        var self = this;

        return (
            <gallery-item>
                <a href={item.link || "#"} className="image-container">
                    {!imgError ? (
                        <img
                            ref={function (el) { self.imgRef = el; }}
                            src={item.image + (item.image.indexOf("?") === -1 ? "?width=500" : "")}
                            alt={item.name}
                            className="lazy-image gallery-item-image"
                            onError={this.handleImageError}
                        />
                    ) : (
                        <div className="gallery-item-placeholder"><image-placeholder></image-placeholder></div>
                    )}
                </a>
                <div className="gallery-item-info">
                    {item.collection && <span className="gallery-item-collection">{item.collection}</span>}
                    <span className="gallery-item-title">{item.name}</span>
                    <span className="gallery-item-sku">{item.sku}</span>
                    {item.price && <span className="gallery-item-price">From: {item.price}</span>}
                    <span className="gallery-item-type">{item.itemType}</span>
                </div>
                <button
                    className="favorites-remove-btn"
                    onClick={function (e) { e.preventDefault(); self.props.onRemove(item); }}
                    title="Remove from list"
                >
                    &times;
                </button>
            </gallery-item>
        );
    }
}

export default class FavoritesGalleryComponent extends React.Component {
    constructor(props) {
        super(props);
        var lists = props.lists || [];
        var items = props.items || [];
        this.state = {
            lists: lists,
            selectedList: lists.length > 0 ? lists[0] : null,
            items: items,
            filteredItems: items,
            searchTerm: "",
            sortBy: null,
            showCreatePopup: false,
            newListName: "",
            showPrintPopup: false,
            printPerPage: 4,
            printShowPricing: false,
            printAddContact: false,
            printMessage: "",
            printGenerating: false
        };
    }

    onListChange = (e) => {
        var list = e.value;
        this.setState({ selectedList: list, searchTerm: "", sortBy: null });
        this.loadItems(list.id);
    }

    loadItems = (listId) => {
        var self = this;
        fetch("/api/Favorite/Items/" + listId, { credentials: "same-origin" })
            .then(function (res) { return res.ok ? res.json() : []; })
            .then(function (items) {
                self.setState({ items: items, filteredItems: items });
            });
    }

    onSubmitSearch = (value) => {
        var items = this.state.items;
        if (!value || value.trim() === "") {
            this.setState({ filteredItems: items, searchTerm: "" });
            return;
        }
        var q = value.trim().toLowerCase();
        var filtered = items.filter(function (item) {
            return (item.sku || "").toLowerCase().indexOf(q) !== -1 ||
                (item.name || "").toLowerCase().indexOf(q) !== -1 ||
                (item.collection || "").toLowerCase().indexOf(q) !== -1;
        });
        this.setState({ filteredItems: filtered, searchTerm: value });
    }

    onSortChange = (sortBy) => {
        var val = Array.isArray(sortBy) ? sortBy[0] : sortBy;
        if (!val) return;
        var params = val.split("|");
        var field = params[0];
        var direction = params[1];
        var sorted = sortByProperty(this.state.filteredItems.slice(), field, direction);
        this.setState({ filteredItems: sorted, sortBy: sortBy });
    }

    onCreateList = () => {
        this.setState({ showCreatePopup: true, newListName: "" });
    }

    onCreateListSubmit = () => {
        var name = this.state.newListName;
        if (!name || !name.trim()) return;
        var self = this;
        fetch("/api/Favorite/CreateList", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ name: name.trim() })
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            if (data.success) {
                var newList = { id: data.id, name: data.name, itemCount: 0 };
                var lists = self.state.lists.concat([newList]);
                self.setState({ lists: lists, selectedList: newList, items: [], filteredItems: [], showCreatePopup: false, newListName: "" });
            }
        });
    }

    onCreateListCancel = () => {
        this.setState({ showCreatePopup: false, newListName: "" });
    }

    onDeleteList = () => {
        var selectedList = this.state.selectedList;
        if (!selectedList) return;
        if (!confirm("Delete \"" + selectedList.name + "\" and all its items?")) return;
        var self = this;
        fetch("/api/Favorite/List/" + selectedList.id, {
            method: "DELETE",
            credentials: "same-origin"
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            if (data.success) {
                var fLabel = data.totalCount > 99 ? "99+" : String(data.totalCount);
                document.querySelectorAll(".favorites-badge-count").forEach(function(badge){
                    badge.textContent = fLabel;
                    badge.style.display = data.totalCount > 0 ? "" : "none";
                });
                var lists = self.state.lists.filter(function (l) { return l.id !== selectedList.id; });
                var newSelected = lists.length > 0 ? lists[0] : null;
                self.setState({ lists: lists, selectedList: newSelected, items: [], filteredItems: [] });
                if (newSelected) {
                    self.loadItems(newSelected.id);
                }
            }
        });
    }

    onRemove = (item) => {
        var self = this;
        fetch("/api/Favorite/Item/" + item.id, {
            method: "DELETE",
            credentials: "same-origin"
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            if (data.success) {
                var fLabel = data.totalCount > 99 ? "99+" : String(data.totalCount);
                document.querySelectorAll(".favorites-badge-count").forEach(function(badge){
                    badge.textContent = fLabel;
                    badge.style.display = data.totalCount > 0 ? "" : "none";
                });
                var lists = self.state.lists.map(function (l) {
                    if (self.state.selectedList && l.id === self.state.selectedList.id) {
                        return Object.assign({}, l, { itemCount: l.itemCount - 1 });
                    }
                    return l;
                });
                var selectedList = self.state.selectedList;
                if (selectedList) {
                    selectedList = lists.find(function (l) { return l.id === selectedList.id; });
                }
                var items = self.state.items.filter(function (i) { return i.id !== item.id; });
                var filteredItems = self.state.filteredItems.filter(function (i) { return i.id !== item.id; });
                self.setState({ lists: lists, selectedList: selectedList, items: items, filteredItems: filteredItems });
            }
        });
    }

    onPrintList = () => {
        this.setState({ showPrintPopup: true, printPerPage: 4, printShowPricing: false, printAddContact: false, printMessage: "", printGenerating: false });
    }

    onPrintCancel = () => {
        this.setState({ showPrintPopup: false });
    }

    loadImageAsDataUrl = (url) => {
        // Try fetch first (avoids CORS canvas taint issues)
        return fetch(url, { mode: "cors" })
            .then(function (res) {
                if (!res.ok) throw new Error("fetch failed");
                return res.blob();
            })
            .then(function (blob) {
                return new Promise(function (resolve) {
                    var dataUrl;
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        dataUrl = reader.result;
                        var img = new Image();
                        img.onload = function () { resolve({ dataUrl: dataUrl, w: img.naturalWidth, h: img.naturalHeight }); };
                        img.onerror = function () { resolve({ dataUrl: dataUrl, w: 1, h: 1 }); };
                        img.src = dataUrl;
                    };
                    reader.onerror = function () { resolve(null); };
                    reader.readAsDataURL(blob);
                });
            })
            .catch(function () {
                // Fallback to canvas approach
                return new Promise(function (resolve) {
                    var img = new Image();
                    img.crossOrigin = "anonymous";
                    img.onload = function () {
                        var canvas = document.createElement("canvas");
                        canvas.width = img.naturalWidth;
                        canvas.height = img.naturalHeight;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        try {
                            resolve({ dataUrl: canvas.toDataURL("image/jpeg", 0.85), w: img.naturalWidth, h: img.naturalHeight });
                        } catch (e) {
                            resolve(null);
                        }
                    };
                    img.onerror = function () { resolve(null); };
                    img.src = url;
                });
            });
    }

    loadSvgAsDataUrl = (url, width, height) => {
        return new Promise(function (resolve) {
            var img = new Image();
            img.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);
                try {
                    resolve(canvas.toDataURL("image/png"));
                } catch (e) {
                    resolve(null);
                }
            };
            img.onerror = function () { resolve(null); };
            img.src = url;
        });
    }

    loadFontAsBase64 = (url) => {
        return fetch(url)
            .then(function (res) { return res.arrayBuffer(); })
            .then(function (buf) {
                var binary = "";
                var bytes = new Uint8Array(buf);
                for (var i = 0; i < bytes.length; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return btoa(binary);
            })
            .catch(function () { return null; });
    }

    onPrintGenerate = async () => {
        this.setState({ printGenerating: true });
        var items = this.state.items;
        // Enrich with LIVE catalog data (current price + PDP-format
        // dimensions) — the stored favorite rows carry a price snapshot
        // that's empty on legacy items and never carry dimensions. Falls
        // back to on-screen items if the endpoint fails.
        if (this.state.selectedList && this.state.selectedList.id) {
            try {
                var resp = await fetch('/api/Favorite/PrintItems/' + this.state.selectedList.id, { credentials: 'same-origin' });
                if (resp.ok) {
                    var enriched = await resp.json();
                    if (enriched && enriched.length) items = enriched;
                }
            } catch (e) { /* keep on-screen items */ }
        }
        var perPage = this.state.printPerPage;
        var showPricing = this.state.printShowPricing;
        var addContact = this.state.printAddContact;
        var message = this.state.printMessage;
        var listName = this.state.selectedList ? this.state.selectedList.name : "Favorites";

        var jsPDF = window.jspdf && window.jspdf.jsPDF;
        if (!jsPDF) {
            await new Promise(function (resolve, reject) {
                var script = document.createElement("script");
                script.src = "/js/lib/jspdf.umd.min.js";
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
            jsPDF = window.jspdf && window.jspdf.jsPDF;
            if (!jsPDF) {
                alert("Failed to load PDF library.");
                this.setState({ printGenerating: false });
                return;
            }
        }
        var doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "letter" });

        // Load and register custom fonts
        var fontsLoaded = false;
        try {
            var gibsonBook = await this.loadFontAsBase64("/css/fonts/Gibson-Book.ttf");
            var gibsonMedium = await this.loadFontAsBase64("/css/fonts/Gibson-Medium.ttf");
            var utopia = await this.loadFontAsBase64("/css/fonts/UtopiaStd-Disp.ttf");

            if (gibsonBook) {
                doc.addFileToVFS("Gibson-Book.ttf", gibsonBook);
                doc.addFont("Gibson-Book.ttf", "Gibson", "normal");
            }
            if (gibsonMedium) {
                doc.addFileToVFS("Gibson-Medium.ttf", gibsonMedium);
                doc.addFont("Gibson-Medium.ttf", "Gibson", "bold");
            }
            if (utopia) {
                doc.addFileToVFS("UtopiaStd-Disp.ttf", utopia);
                doc.addFont("UtopiaStd-Disp.ttf", "Utopia", "normal");
            }
            fontsLoaded = gibsonBook && gibsonMedium && utopia;
        } catch (e) {
            fontsLoaded = false;
        }

        var fontBody = fontsLoaded ? "Gibson" : "helvetica";
        var fontHeader = fontsLoaded ? "Utopia" : "helvetica";

        // Load logo
        var logoDataUrl = await this.loadImageAsDataUrl("/images/logos/fairfield-logo-2.png");

        var pageW = doc.internal.pageSize.getWidth();
        var pageH = doc.internal.pageSize.getHeight();
        var margin = 40;
        var contentW = pageW - margin * 2;
        var logoW = 220;
        var logoH = 220 * (81 / 558); // maintain aspect ratio of logo image
        var headerHeight = logoH + 30; // logo + title + spacing

        // Helper to render page header (logo + list title)
        var renderPageHeader = function (doc) {
            var headerY = margin;
            if (logoDataUrl && logoDataUrl.dataUrl) {
                try {
                    doc.addImage(logoDataUrl.dataUrl, "PNG", (pageW - logoW) / 2, headerY, logoW, logoH);
                } catch (e) { /* skip logo */ }
            }
            doc.setFont(fontHeader, "normal");
            doc.setFontSize(18);
            doc.setTextColor(0);
            doc.text(listName, pageW / 2, headerY + logoH + 30, { align: "center" });
            return headerY + headerHeight + 14;
        };

        var yPos = renderPageHeader(doc);

        // Grid layout
        var cols, imgSize, cellW, cellH, textFontSize;
        if (perPage === 1) {
            cols = 1; imgSize = 360; textFontSize = 12;
        } else if (perPage === 2) {
            cols = 1; imgSize = 240; textFontSize = 11;
        } else if (perPage === 4) {
            cols = 2; imgSize = 180; textFontSize = 10;
        } else {
            cols = 3; imgSize = 120; textFontSize = 9;
        }

        cellW = contentW / cols;
        // Cell height must fit the tallest text block on the page:
        // collection + name + sku (3) + dimensions (when any item has
        // them) + price (when pricing enabled).
        var anyDimensions = false;
        for (var di0 = 0; di0 < items.length; di0++) {
            if (items[di0].dimensions) { anyDimensions = true; break; }
        }
        var textLines = 3 + (anyDimensions ? 1 : 0) + (showPricing ? 1 : 0);
        cellH = imgSize + textFontSize * textLines + 30;

        var rowsPerPage = Math.floor((pageH - yPos - margin) / cellH);
        if (rowsPerPage < 1) rowsPerPage = 1;

        // Pre-load all images
        var imageDataUrls = [];
        for (var i = 0; i < items.length; i++) {
            var imgUrl = items[i].image;
            if (imgUrl && imgUrl.indexOf("?") === -1) imgUrl += "?width=500";
            var dataUrl = await this.loadImageAsDataUrl(imgUrl);
            imageDataUrls.push(dataUrl);
        }

        var itemIndex = 0;
        var pageStartY = yPos;
        var isFirstPage = true;

        while (itemIndex < items.length) {
            if (!isFirstPage) {
                doc.addPage();
                pageStartY = renderPageHeader(doc);
            }
            isFirstPage = false;

            var currentPageRows = Math.floor((pageH - pageStartY - margin) / cellH);
            if (currentPageRows < 1) currentPageRows = 1;
            var currentPageItems = currentPageRows * cols;

            for (var p = 0; p < currentPageItems && itemIndex < items.length; p++) {
                var item = items[itemIndex];
                var col = p % cols;
                var row = Math.floor(p / cols);
                var x = margin + col * cellW;
                var y = pageStartY + row * cellH;

                // Center image in cell, preserving aspect ratio
                var imgData = imageDataUrls[itemIndex];
                if (imgData) {
                    var fitRatio = Math.min(imgSize / imgData.w, imgSize / imgData.h);
                    var fitW = imgData.w * fitRatio;
                    var fitH = imgData.h * fitRatio;
                    var imgX = x + (cellW - fitW) / 2;
                    var imgY = y + (imgSize - fitH) / 2;
                    try {
                        doc.addImage(imgData.dataUrl, "JPEG", imgX, imgY, fitW, fitH);
                    } catch (e) { /* skip image */ }
                }

                // Text below image
                var textY = y + imgSize + 14;
                var textX = x + cellW / 2;

                if (item.collection) {
                    doc.setFont(fontBody, "normal");
                    doc.setFontSize(textFontSize - 1);
                    doc.setTextColor(120);
                    doc.text(item.collection, textX, textY, { align: "center" });
                    textY += textFontSize + 2;
                }

                doc.setTextColor(0);
                doc.setFont(fontHeader, "normal");
                doc.setFontSize(textFontSize);
                doc.text(item.name || "", textX, textY, { align: "center" });
                textY += textFontSize + 2;

                doc.setFont(fontBody, "normal");
                doc.setFontSize(textFontSize - 1);
                doc.setTextColor(100);
                doc.text(item.sku || "", textX, textY, { align: "center" });
                textY += textFontSize + 2;
                doc.setTextColor(0);

                // Overall dimensions — same string as the PDP
                // (e.g. 30.00"w x 33.50"d x 37.50"h), frames only.
                if (item.dimensions) {
                    doc.setFont(fontBody, "normal");
                    doc.setFontSize(textFontSize - 1);
                    doc.setTextColor(100);
                    doc.text(item.dimensions, textX, textY, { align: "center" });
                    textY += textFontSize + 2;
                    doc.setTextColor(0);
                }

                if (showPricing && item.price) {
                    doc.setFont(fontBody, "normal");
                    doc.setFontSize(textFontSize);
                    doc.text("From: " + item.price, textX, textY, { align: "center" });
                }

                itemIndex++;
            }

            // Page number
            doc.setFont(fontBody, "normal");
            doc.setFontSize(8);
            doc.setTextColor(150);
            var pageNum = doc.internal.getNumberOfPages();
            doc.text("Page " + pageNum, pageW / 2, pageH - 20, { align: "center" });
            doc.setTextColor(0);
        }

        // Render contact info and notes at the bottom of the last page
        var lastPageNum = doc.internal.getNumberOfPages();
        doc.setPage(lastPageNum);
        var footerY = pageH - margin;

        // Calculate space needed
        var footerLines = 0;
        if (message) {
            var noteLines = doc.splitTextToSize("NOTES: " + message, contentW);
            footerLines += noteLines.length;
        }
        if (addContact) footerLines += 3;
        var footerHeight = footerLines * 14 + 24;
        footerY = pageH - margin - footerHeight;

        if (addContact) {
            doc.setFont(fontBody, "normal");
            doc.setFontSize(10);
            doc.setTextColor(0);
            doc.text("Contact: Fairfield Chair Company", margin, footerY);
            footerY += 14;
            doc.text("1331 Harper Ave SW, Lenoir, NC 28645", margin, footerY);
            footerY += 14;
            doc.text("Phone: 828.758.5571  |  Email: info@fairfieldchair.com", margin, footerY);
            footerY += 24;
        }

        if (message) {
            doc.setFont(fontBody, "normal");
            doc.setFontSize(10);
            doc.setTextColor(0);
            var noteText = doc.splitTextToSize("NOTES: " + message, contentW);
            doc.text(noteText, margin, footerY);
        }

        doc.save(listName.replace(/[^a-zA-Z0-9]/g, "-") + ".pdf");
        this.setState({ printGenerating: false, showPrintPopup: false });
    }

    renderPrintPopup() {
        var self = this;
        var perPage = this.state.printPerPage;
        var layouts = [1, 2, 4, 9];

        return (
            <div className="favorites-print-overlay" onClick={(e) => { if (e.target === e.currentTarget) this.onPrintCancel(); }}>
                <div className="favorites-print-popup">
                    <div className="favorites-print-header">
                        <button className="favorites-popup-close" onClick={this.onPrintCancel}>&times;</button>
                        <h3>Download Favorites</h3>
                    </div>
                    <div className="favorites-print-body">
                        <label className="favorites-print-checkbox">
                            <input type="checkbox" checked={this.state.printAddContact} onChange={(e) => this.setState({ printAddContact: e.target.checked })} />
                            <span>Add Contact Information</span>
                        </label>

                        <div className="favorites-print-divider"></div>

                        <h4 className="favorites-print-section-title">Quantity of Items Per Page</h4>
                        <div className="favorites-print-layouts">
                            {layouts.map(function (count) {
                                var cls = "favorites-print-layout" + (perPage === count ? " active" : "");
                                return (
                                    <button key={count} className={cls} onClick={() => self.setState({ printPerPage: count })}>
                                        <div className="favorites-print-layout-icon" data-count={count}>
                                            {self.renderLayoutIcon(count)}
                                        </div>
                                        <span>{count}</span>
                                    </button>
                                );
                            })}
                        </div>

                        <label className="favorites-print-checkbox">
                            <input type="checkbox" checked={this.state.printShowPricing} onChange={(e) => this.setState({ printShowPricing: e.target.checked })} />
                            <span>Show Pricing</span>
                        </label>
                        <label className="favorites-print-checkbox">
                            <input type="checkbox" checked={!this.state.printShowPricing} onChange={(e) => this.setState({ printShowPricing: !e.target.checked })} />
                            <span>Hide Pricing</span>
                        </label>

                        <textarea
                            className="favorites-print-message"
                            placeholder="Message"
                            value={this.state.printMessage}
                            onChange={(e) => this.setState({ printMessage: e.target.value })}
                        ></textarea>
                    </div>
                    <div className="favorites-print-footer">
                        <button className="favorites-print-save" onClick={this.onPrintGenerate} disabled={this.state.printGenerating}>
                            {this.state.printGenerating ? "Generating..." : "Save PDF"}
                        </button>
                        <button className="favorites-print-cancel" onClick={this.onPrintCancel}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }

    renderLayoutIcon(count) {
        // SVG layout icons showing page grid
        var rects = [];
        if (count === 1) {
            rects.push(<rect key="0" x="16" y="8" width="48" height="48" stroke="#888" fill="none" strokeWidth="1" />);
            rects.push(<line key="l1" x1="22" y1="62" x2="58" y2="62" stroke="#888" strokeWidth="1" />);
            rects.push(<line key="l2" x1="26" y1="68" x2="54" y2="68" stroke="#888" strokeWidth="1" />);
        } else if (count === 2) {
            rects.push(<rect key="0" x="16" y="6" width="34" height="30" stroke="#888" fill="none" strokeWidth="1" />);
            rects.push(<line key="l1" x1="18" y1="40" x2="48" y2="40" stroke="#888" strokeWidth="1" />);
            rects.push(<line key="l2" x1="22" y1="45" x2="44" y2="45" stroke="#888" strokeWidth="1" />);
            rects.push(<rect key="1" x="16" y="52" width="34" height="30" stroke="#888" fill="none" strokeWidth="1" />);
            rects.push(<line key="l3" x1="18" y1="86" x2="48" y2="86" stroke="#888" strokeWidth="1" />);
            rects.push(<line key="l4" x1="22" y1="91" x2="44" y2="91" stroke="#888" strokeWidth="1" />);
        } else if (count === 4) {
            rects.push(<rect key="0" x="8" y="6" width="26" height="26" stroke="#888" fill="none" strokeWidth="1" />);
            rects.push(<line key="l1" x1="10" y1="36" x2="32" y2="36" stroke="#888" strokeWidth="1" />);
            rects.push(<rect key="1" x="46" y="6" width="26" height="26" stroke="#888" fill="none" strokeWidth="1" />);
            rects.push(<line key="l2" x1="48" y1="36" x2="70" y2="36" stroke="#888" strokeWidth="1" />);
            rects.push(<rect key="2" x="8" y="50" width="26" height="26" stroke="#888" fill="none" strokeWidth="1" />);
            rects.push(<line key="l3" x1="10" y1="80" x2="32" y2="80" stroke="#888" strokeWidth="1" />);
            rects.push(<rect key="3" x="46" y="50" width="26" height="26" stroke="#888" fill="none" strokeWidth="1" />);
            rects.push(<line key="l4" x1="48" y1="80" x2="70" y2="80" stroke="#888" strokeWidth="1" />);
        } else {
            // 9 items - 3x3
            var positions = [[4,4],[30,4],[56,4],[4,34],[30,34],[56,34],[4,64],[30,64],[56,64]];
            for (var i = 0; i < 9; i++) {
                rects.push(<rect key={i} x={positions[i][0]} y={positions[i][1]} width="20" height="20" stroke="#888" fill="none" strokeWidth="1" />);
            }
        }
        return <svg viewBox="0 0 80 100" width="80" height="100">{rects}</svg>;
    }

    render() {
        var self = this;
        var lists = this.state.lists;
        var selectedList = this.state.selectedList;
        var filteredItems = this.state.filteredItems;
        var count = filteredItems.length;
        var totalCount = this.state.items.length;
        var countLabel = count === 1 ? "item" : "items";

        return (
            <div>
                <div className="gallery-grid">
                    <div className="gallery-items-container">
                        <div className="filters-header-container">
                            <div className="filters-bar-container">
                                <div className="favorites-list-dropdown">
                                    <DropDownList
                                        data={lists}
                                        textField="name"
                                        dataItemKey="id"
                                        value={selectedList}
                                        onChange={this.onListChange}
                                        style={{ width: "250px" }}
                                        itemRender={(li, itemProps) => {
                                            var item = itemProps.dataItem;
                                            return React.cloneElement(li, li.props, (
                                                <span>{item.name} <span style={{ color: "#999", fontSize: "12px" }}>({item.itemCount})</span></span>
                                            ));
                                        }}
                                        valueRender={(element, value) => {
                                            if (!value) return element;
                                            return React.cloneElement(element, element.props, (
                                                <span>{value.name} ({value.itemCount})</span>
                                            ));
                                        }}
                                    />
                                    <div className="favorites-list-actions">
                                        <a className="favorites-action-link" onClick={this.onCreateList}>+ Create New List</a>
                                        <a className="favorites-action-link" onClick={this.onPrintList}>Print Selected List</a>
                                        <a className="favorites-action-link delete" onClick={this.onDeleteList}>Delete Selected List</a>
                                    </div>
                                </div>
                            </div>
                            <div className="gallery-items-count">
                                <GallerySearchBar onSubmitSearch={this.onSubmitSearch} />
                                <SortBar onSortChange={this.onSortChange} excludePriceSort={true} />
                                <span className="count-label">{count}&nbsp;of&nbsp;{totalCount}&nbsp;{countLabel}</span>
                            </div>
                        </div>
                        <div className="gallery-items-list lazy-image-disabled">
                            <shopping-gallery>
                                {filteredItems.map(function (item) {
                                    return <FavoriteItem key={item.id} item={item} onRemove={self.onRemove} />;
                                })}
                            </shopping-gallery>
                            {count === 0 && (
                                <div className="gallery-no-results">
                                    No items in this list.
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {this.state.showCreatePopup && (
                    <div className="favorites-create-overlay" onClick={(e) => { if (e.target === e.currentTarget) this.onCreateListCancel(); }}>
                        <div className="favorites-create-popup">
                            <div className="favorites-create-popup-header">
                                <h4>Create New List</h4>
                                <button className="favorites-popup-close" onClick={this.onCreateListCancel}>&times;</button>
                            </div>
                            <div className="favorites-create-popup-body">
                                <label>List Name</label>
                                <input
                                    type="text"
                                    value={this.state.newListName}
                                    onChange={(e) => this.setState({ newListName: e.target.value })}
                                    onKeyDown={(e) => { if (e.key === "Enter") this.onCreateListSubmit(); }}
                                    placeholder="Enter list name"
                                    autoFocus
                                />
                            </div>
                            <div className="favorites-create-popup-footer">
                                <button className="favorites-create-cancel" onClick={this.onCreateListCancel}>Cancel</button>
                                <button className="favorites-create-save" onClick={this.onCreateListSubmit}>Create</button>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.showPrintPopup && this.renderPrintPopup()}
            </div>
        );
    }
}
